<template>
  <!-- 我的订单 -->
  <div class="container">
    <div v-if="!showGoodsDetails">
      <el-card shadow="never" id="myGoods" style="min-height: 700px">
        <div id="resetInput" class="topHandle">
          <div class="search-box">
            <el-input class="box-item" clearable placeholder="输入订单编号" v-model="memberOrderListParams.orderCode" prefix-icon="el-icon-search" />
            <el-input class="box-item" clearable placeholder="输入预约检测设备" v-model="memberOrderListParams.equipmentName" prefix-icon="el-icon-search" />
            <el-select class="box-item" v-model="memberOrderListParams.prepaidPayment" :clearable="true" placeholder="请选择支付方式">
              <el-option
                v-for="item in prepaidPaymentList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker
              class="box-item"
              v-model="dateList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeDate"
              >
            </el-date-picker>
            <div>
              <el-button @click="resetParams">重置</el-button>
              <el-button type="primary" @click="getSearch()">搜索</el-button>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="i in tabsList" :key="i.index" :label="i.label" :name="i.index.toString()">
            <div class="table_head">
              <div class="table_head_col" :style="{ width: i.width }" v-for="i in headList" :key="i.index">{{ i.name }}</div>
            </div>
            <div class="table_content" v-loading="loading">
              <el-empty v-if="tableData.length == 0" description="暂无订单"></el-empty>
              <div class="table_content_card" v-for="item in tableData" :key="item.index">
                <div class="table_card_head">
                  <span>下单时间：{{ item.orderDate || '-' }}</span>
                  <span>订单号：{{ item.orderCode || '-' }}</span>
                  <span>客户经理：{{ item.clientManager || '-' }}({{ item.clientManagerPhoneNumber || '-' }})</span>
                  <span class="evaluate-desc" v-if="['实验中', '已完成', '待核对', '申请开票', '回运', '售后'].includes(orderStatusToString(item))" @click="evaluationOrder(item)">提交好评，领取双倍积分</span>
                </div>
                <div class="table_card_body" @click="toDetails(item)">
                  <div class="table_body_name">
                    <div>
                      <el-image
                        :src="(item.fileList && item.fileList.length) > 0 ? imgurl + item.fileList[0].url : '../../assets/img/morentupian.png'"
                        class="goodsequipImg">
                        <div slot="error">
                          <img class="goodsequipImg" src="../../assets/img/morentupian.png" />
                        </div>
                      </el-image>
                    </div>
                    <div>{{ item.equipmentName }}</div>
                  </div>
                  <div class="table_body_othername">{{ dictFilter(item.prepaidPayment ? item.prepaidPayment.toString() : '-', 'prepaidPayment') }}</div>
                  <div class="table_body_othername">{{ orderStatusToString(item) == '待议价' ? '--' : `￥${item[selectMoneyKey(item)]}` }}</div>
                  <div class="table_body_othername font14666">{{ orderStatusToString(item) }}</div>
                  <div class="table_body_othername font14666">
                    <el-tooltip v-if="orderStatusToString(item) == '已完成' && item.billStatus == 3" class="item" effect="light" content="无需开票：预存支付的订单，包括团队预存和个人预存" placement="top">
                      <div>
                        <svg-icon icon-class="tips" v-if="item.billStatus === 3" style="margin-right: 3px"/>
                        <span>{{ dictFilter(item.billStatus ? item.billStatus.toString() : '-', 'invoiceOrderStatus') }}</span>
                      </div>
                    </el-tooltip>
                    <span v-else>{{ dictFilter(item.billStatus ? item.billStatus.toString() : '-', 'invoiceOrderStatus') }}</span> 
                  </div>
                  <div class="table_body_btn">
                    <div class="clickName" v-if="pay_order(item)" @click.stop="toPay(item)">立即支付</div>
                    <div class="clickName" v-if="upload_pack(item)" @click.stop="uploadHandle(item)">上传包裹信息</div>
                    <div class="clickName" v-if="cancel_order(item)" @click.stop="cancellationHandle(item)">取消订单</div>
                    <div class="clickName" v-if="price_objection(item)" @click.stop="priceObjection(item)">价格疑异</div>
                    <div class="clickName" v-if="again_order(item)" @click.stop="againOrder(item)">再来一单</div>
                    <div class="clickName" v-if="show_invoice(item)" @click.stop="openInvoice(item)">查看发票</div>
                    <div class="clickName" v-if="apply_service(item)" @click.stop="openApplyServiceDialog(item)">申请售后</div>
                    <div class="clickName" v-if="confirm_result(item)" @click.stop="confirmResult(item)">
                      <span>下载实验数据</span>
                      <svg-icon class="new-icon" v-if="item.dataDownloadStatus == 0" :icon-class="'new'"/>
                    </div><!-- 弹出确认结果弹框 -->
                    <div class="clickName" v-if="download_result(item)" @click.stop="fileHandle(item)">
                      <span>下载实验数据</span>
                      <svg-icon class="new-icon" v-if="item.dataDownloadStatus == 0" :icon-class="'new'"/>
                    </div><!-- 直接下载结果 -->
                    <el-popover
                      v-if="connect_kefu(item)"
                      placement="right"
                      width="200"
                      trigger="hover">
                      <img style="width: 200px;" :src="kefuQrCode" alt="">
                      <div slot="reference" class="clickName">联系客服</div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div class="total-money">
                <span>累计检测金额： </span>
                <span style="margin-right: 8px; color: #FF4A2B;">￥{{ totalCost.total }} </span>
                <el-tooltip class="item" effect="dark" :content="`个人累计检测金额： ￥${ totalCost.client } / 团队累计检测金额： ￥${ totalCost.team } `" placement="top">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
              <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px"
              layout="total,prev, pager, next,sizes,jumper" :current-page="memberOrderListParams.pageNum"
              :page-size="memberOrderListParams.pageSize" :total="total" @current-change="selPageChange"
              @size-change="handleSizeChange">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
    <!-- 订单详情 -->
    <goodsDetails ref="goodsDetails" v-if="showGoodsDetails" @downloadResult="fileHandle" @close="getList"></goodsDetails>
    <!-- 申请售后 -->
    <applyServiceDialog ref="applyServiceDialog" :clientSubmitAfterSafesData="clientSubmitAfterSafesData" @refesh="getList"></applyServiceDialog>
    <!-- 上传包裹信息 -->
    <uploadPackage v-if="uploadPackage" ref="package" @refesh="getList"></uploadPackage>
    <!-- 确认结果 -->
    <confirmResult v-if="confirmVisible" ref="confirm" @downloadResult="downloadResult" @refesh="getList"></confirmResult>
    <!-- 复制实验结果链接弹框 -->
    <el-dialog title="提示" :visible.sync="downloadFileListDialog" width="40%">
      <div class="downloadfile-title">存在多个实验结果的订单，下载实验数据时，需手动<span style="color: #FF4A2B; font-weight: 600;">点击</span>复制相应数据链接，前往浏览器粘贴打开以下载！</div>
      <div class="file-link" v-for="(item, index) in downloadFileList" :key="index" @click="copyLink(item)">{{ item }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadFileListDialog = false">关  闭</el-button>
      </div>
    </el-dialog>
    <!-- 确认评价 -->
    <evaluation ref="evaluation" v-if="evaluationVisible" @close="getList"></evaluation>
</div>
</template>

<script>
import goodsDetails from "./goodsDetails";
import uploadPackage from "./formPop/uploadPackage";
import confirmResult from "./formPop/confirmResult";
import applyServiceDialog from "./formPop/applyServiceDialog"
import evaluation from "./formPop/evaluation";
import { moneyKey, orderStatus } from "@/utils/order.js"
import {
  memberOrderList,
  cancelOrder,
  orderInfo,
  getDownLoadUrl,
  clientSubmitAfterSafes,
  getOrderInvoiceInfo,
} from "@/api/request";
import { getClient } from "@/plugins/auth";
export default {
  components: {
    goodsDetails,
    uploadPackage,
    confirmResult,
    applyServiceDialog,
    evaluation,
  },
  data() {
    return {
      loading: false,
      kefuQrCode: localStorage.getItem('serviceQRCode'),//客服二维码
      activeName: "0",
      showGoodsDetails: false,
      imgurl: process.env.VUE_APP_FILE_API,
      search: "",
      total: 0,
      uploadPackage: false,
      confirmVisible: false,
      userInfo: JSON.parse(getClient()),
      downloadFileList: [],//实验结果下载链接 列表
      downloadFileListDialog: false,//实验结果下载链接  弹框
      evaluationVisible: false,//评价弹框
      //订单列表接口上传参数
      dateList: [],
      memberOrderListParams: {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        orderCode: '',
        equipmentName: '',
        prepaidPayment: '',
        orderDateBegin: '',
        orderDateEnd: '',
      },
      //提交售后接口上传数据
			clientSubmitAfterSafesData: {
				orderId: null,
				afterSalesDesc: ''
			},
      headList: [
        { name: "检测项目", index: 1, width: "200px" },
        { name: "支付方式", index: 2, width: "80px" },
        { name: "应付款", index: 3, width: "80px" },
        { name: "订单状态", index: 4, width: "80px" },
        { name: "发票状态", index: 5, width: "80px" },
        { name: "操作", index: 6, width: "170px" }
      ],
      tableData: [],
      // 累计检测金额
			totalCost: {
				client: 0,
				team: 0,
				total: 0
			},
      tabsList: [
        //除去 “全部订单” ，没有value的，都是需要组合字段的状态
				{label: '全部订单', index: 0},
				{label: '待支付', index: 1, value: 1},
				{label: '待审核', index: 2, value: 10},
				{label: '待寄样/取样', index: 3},
				{label: '已寄样/取样', index: 4},
				{label: '待实验', index: 5, value: 4},
				{label: '实验中', index: 6, value: 5},
				{label: '待核对', index: 7, value: 12},
				{label: '已取消', index: 8, value: 8},
				{label: '售后/回运', index: 9},
				{label: '已完成', index: 10},
				{label: '申请开票', index: 11, value: 9},
      ],
      prepaidPaymentList: [
        { value: 1, label: "个人预存" },
        { value: 2, label: "团队预存" },
        { value: 3, label: "支付宝" },
        { value: 4, label: "微信" },
        { value: 5, label: "个人信用" },
        { value: 6, label: "团队信用" },
      ],
    };
  },
  watch: {
    activeName(newValue) {
      if(newValue == '7') {
        this.headList[2].name = '实付款'
      } else {
        this.headList[2].name = '应付款'
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    cancel_order(item) {
			const arr = ['待议价', '待支付', '待审核', '待寄样', '待取样']
			return arr.includes(this.orderStatusToString(item))
		},
		pay_order(item) {
			const arr = ['待支付']
			return arr.includes(this.orderStatusToString(item)) && item.bargainStatus != 1
		},
		upload_pack(item) {
			const arr = ['待寄样']
			return arr.includes(this.orderStatusToString(item))
		},
		price_objection(item) {
			const arr = ['待核对']
			return arr.includes(this.orderStatusToString(item))
		},
		confirm_result(item) {
			const arr = ['待核对']
			return arr.includes(this.orderStatusToString(item))
		},
		download_result(item) {
			const arr = ['已完成', '回运']
			return arr.includes(this.orderStatusToString(item))
		},
		again_order(item) {
			const arr = ['已完成']
			return arr.includes(this.orderStatusToString(item)) && !item.isGroupBuy
		},
		apply_service(item) {
			const arr = ['回运', '已完成']
			return arr.includes(this.orderStatusToString(item))
		},
		show_invoice(item) {
			const arr = ['已完成']
			return arr.includes(this.orderStatusToString(item)) && item.billStatus == 2 && (item.prepaidPayment != 1 || item.prepaidPayment != 2)
		},
		connect_kefu(item) {
			const arr = ['售后', '回运']
			return arr.includes(this.orderStatusToString(item))
		},
    // 初始化订单列表
    init(){
      this.memberOrderListParams = {
        pageNum: 1,
        pageSize: 10
      }
      this.getList();
    },
    //获取订单列表
    getList() {
      this.loading = true
      this.showGoodsDetails = false;
      memberOrderList(this.memberOrderListParams).then(res => {
        this.tableData = res.data.data.list
        this.total = res.data.data.total;
        this.totalCost = {
					client: (+res.data.data.clientStat).toFixed(2),
					team: (+res.data.data.teamStat).toFixed(2),
					total: (+res.data.data.clientStat + +res.data.data.teamStat).toFixed(2),
				}
        this.loading = false
      });
    },
    //重置筛选条件
    resetParams() {
      this.dateList = []
      this.memberOrderListParams = {
        pageNum: 1,
        pageSize: 10,
      }
      const tab = { 
        name: this.activeName,
      }
      this.handleClick(tab)
    },
    handleClick(tab) {
      const { orderCode, equipmentName, prepaidPayment, orderDateBegin, orderDateEnd } = this.memberOrderListParams
      this.memberOrderListParams = {
        orderCode,
        equipmentName,
        prepaidPayment,
        orderDateBegin,
        orderDateEnd,
				pageNum: 1,
        pageSize: 10,
        status: undefined,
			}
			if(tab.name == 0) {
				this.getList()
				return
			}
      const data = this.tabsList.find(item => item.index == tab.name)
			if(data.index == 3) {
				this.memberOrderListParams.customWaitStatus = true
				this.getList()
				return
			}
			if(data.index == 4) {
				this.memberOrderListParams.customHasStatus = true
				this.getList()
				return
			}
			if(data.index == 9) { 
				this.memberOrderListParams.status = 7
				this.memberOrderListParams.customBackStatus = true
				this.getList()
				return
			}
			if(data.index == 10) {
				this.memberOrderListParams.status = 7
				this.memberOrderListParams.noAfterSalesStatus = '1'
				this.memberOrderListParams.noRecycleStatus = '2'
				this.getList()
				return
			}
			this.memberOrderListParams.status = data.value
			this.getList()
    },
    changeDate(e) {
      this.memberOrderListParams.orderDateBegin = e ? e[0] : ''
      this.memberOrderListParams.orderDateEnd = e ? e[1] : ''
    },
    toDetails(item) {
      this.showGoodsDetails = true;
      this.$nextTick(() => {
        this.$refs.goodsDetails.getOrderInfo(item.orderId);
      });
    },
    selPageChange(page) {
      this.memberOrderListParams.pageNum = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.memberOrderListParams.pageSize = val;
      this.getList();
    },
    getSearch() {
      this.memberOrderListParams.pageNum = 1;
      this.getList();
    },
    uploadHandle(item) {
      this.uploadPackage = true;
      this.$nextTick(() => {
        this.$refs.package.init(item);
      });
    },
    // 确认结果后下载实验结果
    downloadResult(data) {
      this.fileHandle(data)
    },
    async fileHandle(data) {
      this.loading = true
      const orderInfoRes = await orderInfo(data.orderId)
      const getFileList = orderInfoRes.data.experimentalDataList.map(item => {
        const obj = {
          key: item.url,
          attname: item.name
        }
        return getDownLoadUrl(obj)
      })
      const promiseRes = await Promise.all(getFileList)
      this.downloadFileList = promiseRes.map(item => {
        return item.msg
      })
      this.loading = false
      if (this.downloadFileList.length == 1) {
        this.$confirm("确认是否下载实验数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          window.open(this.downloadFileList[0])
        });
      } else if (this.downloadFileList.length > 1) {
        this.downloadFileListDialog = true
      } else {
        this.$message.error("暂无可下载实验数据");
      }
    },
    //立即支付
    toPay(row) {
      this.$router.push({
        path: "/immediatePay",
        query: {
          id: row.subEquipmentId,
          orderId: row.orderId,
          type: this.$route.query.type ? this.$route.query.type : 0,
          page: "myGoods"
        }
      });
    },
    // 取消
    cancellationHandle(row) {
      this.$confirm("确认取消订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      }).then(function () {
        return cancelOrder({ orderId: row.orderId });
      }).then(() => {
        this.getList();
        this.$message.success("操作成功");
      });
    },
    // 提交价格疑异
		priceObjection(row) {
      this.$confirm("是否确认提交价格疑异？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      }).then(() => {
        this.clientSubmitAfterSafesData.orderId = row.orderId
			  this.clientSubmitAfterSafesData.afterSalesDesc = '价格疑异'
        return clientSubmitAfterSafes(this.clientSubmitAfterSafesData)
      }).then(() => {
        this.getList();
        this.$message.success("价格疑异提交成功");
      })
		},
    // 再来一单
    againOrder(item) {
      this.$router.push({
        path: "/appointPage",
        query: {
          mode: 'againOrder',
          id: item.subEquipmentId,
          orderId: item.orderId,
        },
      });
    },
    // 申请售后
		openApplyServiceDialog(row) {
			this.clientSubmitAfterSafesData.orderId = row.orderId
      this.$refs.applyServiceDialog.open()
		},
    // 查看订单发票
		openInvoice(row) {
      getOrderInvoiceInfo({orderId: row.orderId}).then((res) => {
        const path = this.imgurl + res.data.invoiceFileList[0].url
        window.open(path, '_blank')
      })
		},
    //确认结果
    confirmResult(row) {
      this.confirmVisible = true;
      this.$nextTick(() => {
        this.$refs.confirm.init(row);
      });
    },
    //分情况选择金额展示字段
		selectMoneyKey(data) {
			return moneyKey(data)
		},
    // 翻译订单状态
		orderStatusToString(data) {
			return orderStatus(data)
		},
    //复制实验结果链接
    async copyLink(url) {
      try {
        await navigator.clipboard.writeText(url);
        this.$message.success('复制成功！')
      } catch {
        this.$message.error('写入剪贴板失败！')
      }
    },
    //评价订单
    evaluationOrder(item) {
      this.evaluationVisible = true
      this.$nextTick(() => {
        this.$refs.evaluation.init(item);
      })
    },
  }
};
</script>

<style>
#myGoods .el-card__body {
  padding: 10px 35px;
}

#myGoods .el-tabs__content {
  overflow: inherit;
}
</style>

<style scoped lang="scss">
.container {
  width: 100%;
  height: calc(100vh - 200px);
}
.el-message-box {
  width: fit-content !important;
  min-width: 400px;
  max-width: 1000px;
}
.topHandle {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .search-box {
    display: flex;
    gap: 10px;
    width: 100%;
    .box-item {
      display: flex;
      width: calc((100% - 40px) / 5);
    }
  }
}

.goodsequipImg {
  width: 80px;
  height: 56px;
  border-radius: 12px;
  margin-right: 5px;
}

.table_head {
  display: flex;
  flex-flow: row nowrap;
  background: #f5f5f5;
  text-align: center;
  justify-content: space-around;
  border-radius: 7px;
  margin: 20px 0;
  color: #111111;
  font-size: 14px;
  padding: 20px;
}

.table_content {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 450px);
}
.table_content_card {
  cursor: pointer;
  margin-bottom: 20px;
  border-radius: 7px;
  border: 1px solid #e0e2ff;
}

.table_card_head {
  font-size: 14px;
  color: #666;
  background: #eaeffa;
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  border-bottom: 1px solid #e0e2ff;
  span {
    margin-right: 50px;
  }
  .evaluate-desc {
    float: right;
    color: #5CC300;
    text-decoration: underline;
  }
}

.table_card_body {
  position: relative;
  padding: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #111;
}

.table_body_name {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 200px;
  text-align: left;
}

.table_body_othername {
  width: 80px;
}

.table_body_btn {
  width: 170px;
  display: flex;
  flex-flow: column;
  .clickName{
    position: relative;
    .new-icon {
      position: absolute;
      top: -8px;
      right: 5px;
      width: 30px;
      height: 30px;
    }
  }
}

.total-money {
  display: flex;
  align-items: center;
}

.downloadfile-title {
  font-size: 14px;
}

.file-link {
  cursor: pointer;
  margin-top: 10px;
  padding: 10px;
  text-decoration: underline;
  color: #5D5D5D;
  border: 1px solid #E8E8E8;
}
.file-link:hover {
  color: #5CC300;
}
</style>